import React from 'react';
import { string } from 'prop-types';
import Decimal from 'decimal.js';
import moment from 'moment-timezone';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  propTypes,
  LINE_ITEM_CUSTOMER_COMMISSION,
  LINE_ITEM_PROVIDER_COMMISSION,
} from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;
const DEPOSITE_MINUTES = 30;
const DEFAULT_MINUTES = 60;

/**
 * Calculates the total price in sub units for multiple line items.
 */
const lineItemsTotal = (lineItems, marketplaceCurrency) => {
  const amount = lineItems.reduce((total, item) => {
    return total.plus(item.lineTotal.amount);
  }, new Decimal(0));
  const currency = lineItems[0] ? lineItems[0].lineTotal.currency : marketplaceCurrency;
  return new Money(amount, currency);
};

/**
 * Checks if line item represents commission
 */
const isCommission = lineItem => {
  return (
    lineItem.code === LINE_ITEM_PROVIDER_COMMISSION ||
    lineItem.code === LINE_ITEM_CUSTOMER_COMMISSION
  );
};

/**
 * Returns non-commission, non-reversal line items
 */
const nonCommissionNonReversalLineItems = lineItems => {
  return lineItems.filter(item => !isCommission(item) && !item.reversal);
};

/**
 * Check if there is a commission line-item for the given user role.
 */
const hasCommission = (lineItems, userRole) => {
  let commissionLineItem = null;

  if (userRole === 'customer') {
    commissionLineItem = lineItems.find(item => item.code === LINE_ITEM_CUSTOMER_COMMISSION);
  } else if (userRole === 'provider') {
    commissionLineItem = lineItems.find(item => item.code === LINE_ITEM_PROVIDER_COMMISSION);
  }
  return !!commissionLineItem;
};

const LineItemRemainingBalanceMaybe = props => {
  const { lineItems, code, userRole, tx, intl, marketplaceCurrency, bookingDates } = props;

  const hasValidDates = Object.keys(bookingDates).length;
  const protectedData = (tx && tx.id && tx.attributes.protectedData) || {};
  const { bookingEndTime, bookingStartTime } = protectedData || {};
  const billedMinutes = hasValidDates ? moment(bookingDates.bookingEnd).diff(bookingDates.bookingStart, 'minutes') : moment(bookingEndTime).diff(bookingStartTime, 'minutes');
  const requestedQuantity = parseFloat((billedMinutes / DEFAULT_MINUTES).toFixed(2));
  const remainingMinutes = billedMinutes - DEPOSITE_MINUTES;
  const updatedQuantity = parseFloat((remainingMinutes / DEFAULT_MINUTES).toFixed(2));

  const unitPurchase = lineItems.find(item => item.code === code && !item.reversal);
  const lineTotal = unitPurchase?.lineTotal?.amount;
  const newLineTotal = hasValidDates ? new Money((lineTotal / requestedQuantity) * updatedQuantity, unitPurchase?.lineTotal?.currency) : new Money(lineTotal * updatedQuantity, unitPurchase?.lineTotal?.currency);
  const subTotal = unitPurchase ? formatMoney(intl, newLineTotal) : null;

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.subTotalLineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage id="LineItemRemainingBalanceMaybe.subTotal" />
        </span>
        <span className={css.itemValue}>{subTotal}</span>
      </div>
    </>
  );
};

LineItemRemainingBalanceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  userRole: string.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemRemainingBalanceMaybe;